import React, { Component, PropTypes } from 'react';

class Pages extends Component {
    render() {
        return (
            <div>
                <hr />
                {this.props.children}
            </div>
        );
    }
}

Pages.propTypes = {
    children: PropTypes.element
};

export default Pages;



// WEBPACK FOOTER //
// ./src/components/pages/Pages.js